var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"findlaw_hflss"},[_c('sec-title',{staticClass:"text_center",attrs:{"Text":"合肥律师事务所"}}),_c('div',{staticClass:"cont between"},[_c('div',[_c('qestlawfirmlist')],1),_c('div',[_c('qestlawfirmlist')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }